import Factura from './Factura';
import Proveedor from './Proveedor';
import moment from 'moment'
import env from '../env.js';

export default class retislr {
    constructor(retislr) {

        if (retislr) {
            this.id = retislr.id || null;
            this.fecha_retencion = moment(retislr.fecha_retencion || Date.now()).toDate() || new Date(Date.now());
            this.numero =  retislr.numero || '';
            this.proveedor = retislr.proveedor ? new Proveedor(retislr.proveedor) : null || null;
            this.tipo_documento = retislr.tipo_documento || '01';
            this.fecha_documento = moment(retislr.fecha_documento || Date.now()).toDate() || new Date(Date.now());
            this.numero_documento = retislr.numero_documento || '';
            this.numero_control = retislr.numero_control || '';
            this.base_retencion = retislr.base_retencion || 0.00;
            this.codigo_retencion = retislr.codigo_retencion || null;
            this.porcentaje_retencion = retislr.porcentaje_retencion || 0.00;
            this.descripcion = retislr.descripcion || '';

            this.duplicate = retislr.duplicate || false;
        }

    }

    sustraendo() {
        return this.porcentaje_retencion/100*env.UND_TRIBUTARIA*83.3334;
    }

    retencion() {
        let sustraendo = 0.00;

        if (this.proveedor.tipo_proveedor === 'PND') {
            sustraendo = this.sustraendo();
        }

        return (this.base_retencion * this.porcentaje_retencion / 100 ) - sustraendo;
    }

    primaryText() {
        return 'No. ' + this.numero;
    }

    _pad(num, size) {
        var s = num+"";
        while (s.length < size) s = "0" + s;
        return s;
    }
}


/** WEBPACK FOOTER **
 ** ./app-react/Models/RetIslr.js
 **/